export default "__VITE_ASSET__dc390a80__"